module.exports = __webpack_public_path__ + "static/media/Login_background.2bf380b9.png";